import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { LeadDetailedResultsRequestDto, LeadsDetailedResultsResponseDto, LeadsType } from "../../types";
import { leadsSearchQueryKeys } from "../key-factory/factory";

type Options = Pick<UseQueryOptions<LeadsDetailedResultsResponseDto>, "enabled">;

export default function useDomainsDetailedResultsQuery(
    leadsType: LeadsType,
    dto: LeadDetailedResultsRequestDto,
    queryOptions: Options = {},
) {
    return useQuery<LeadsDetailedResultsResponseDto>({
        ...queryOptions,
        queryKey: leadsSearchQueryKeys.detailedResults(leadsType, dto),
        // this is complementary data -> intentional to gracefully degrade (show empty data instead of error state)
        throwOnError: false,
        queryFn: ({ signal }) => {
            return salesApiService.leadsSearch[leadsType].fetchDetailedResults(dto, {
                cancellation: signal,
            });
        },
    });
}
